export const TRANSITION = '/transition';
export const CLIENT_CONSENT = '/client-consent';
export const CLIENT_CONSENT_REENROLL = '/client-consent-reenroll';
export const CLIENT_EXPIRED = '/client-expired';
export const CLIENT_REENROLL = '/client-reenroll';
export const CO_CLIENT_CONSENT = '/co-client-consent';
export const CO_CLIENT_CONSENT_REENROLL = '/co-client-consent-reenroll'
export const CO_CLIENT_REENROLL = '/co-client-reenroll';
export const CO_CLIENT_EXPIRED = '/co-client-expired';
export const CONSENT_GIVEN = '/consent-given';
export const CONSENT_GIVEN_REENROLL = '/consent-given-reenroll'
export const APPOINTMENT_INFO = '/appointment-info'
export const APPOINTMENT_INFO_REENROLL = '/appointment-info-reenroll'
export const PLAN_DELIVERED = '/plan-delivered'
export const MONITOR = '/monitor';
export const ACCOUNT_SELECTION = '/account-selection';

export default {
    TRANSITION,
    CLIENT_CONSENT,
    CLIENT_CONSENT_REENROLL,
    CLIENT_EXPIRED,
    CLIENT_REENROLL,
    CO_CLIENT_CONSENT,
    CO_CLIENT_CONSENT_REENROLL,
    CO_CLIENT_REENROLL,
    CO_CLIENT_EXPIRED,
    CONSENT_GIVEN,
    CONSENT_GIVEN_REENROLL,
    APPOINTMENT_INFO,
    APPOINTMENT_INFO_REENROLL,
    PLAN_DELIVERED,
    MONITOR,
    ACCOUNT_SELECTION,
};
